import { createAction } from 'redux-actions';

export const getMfaQrCodeRequest = createAction('GET_MFA_QR_CODE_REQUEST');
export const getMfaQrCodeSuccess = createAction('GET_MFA_QR_CODE_SUCCESS');
export const getMfaQrCodeFail = createAction('GET_MFA_QR_CODE_FAIL');

export const setupMfaRequest = createAction('SETUP_MFA_REQUEST');
export const setupMfaSuccess = createAction('SETUP_MFA_SUCCESS');
export const setupMfaFail = createAction('SETUP_MFA_FAIL');

export const changeMfaRequest = createAction('CHANGE_MFA_REQUEST');
export const changeMfaSuccess = createAction('CHANGE_MFA_SUCCESS');
export const changeMfaFail = createAction('CHANGE_MFA_FAIL');

export const disableMfaRequest = createAction('DISABLE_MFA_REQUEST');
export const disableMfaSuccess = createAction('DISABLE_MFA_SUCCESS');
export const disableMfaFail = createAction('DISABLE_MFA_FAIL');

export const validateMfaRequest = createAction('VALIDATE_MFA_REQUEST');
export const validateMfaSuccess = createAction('VALIDATE_MFA_SUCCESS');
export const validateMfaFail = createAction('VALIDATE_MFA_FAIL');

export const setupPhoneNumberRequest = createAction('SETUP_PHONE_NUMBER_REQUEST');
export const setupPhoneNumberSuccess = createAction('SETUP_PHONE_NUMBER_SUCCESS');
export const setupPhoneNumberFail = createAction('SETUP_PHONE_NUMBER_FAIL');

export const cleanupVerificationInfo = createAction('CLEANUP_VERIFICATION_MFA_INFO');
